export const sliderData = [
  {
    image:
      "https://firebasestorage.googleapis.com/v0/b/avion-aqua.appspot.com/o/images%2Fthril.png?alt=media&token=86f643e7-d129-4590-b15c-1e06b0a85a26",
    heading: "Thril",
  },
  {
    image:
      "https://firebasestorage.googleapis.com/v0/b/avion-aqua.appspot.com/o/images%2Forange.png?alt=media&token=a8cfc0b1-fedf-4189-981c-afd3074b688a",
    heading: "Orange",
  },
  {
    image:
      "https://firebasestorage.googleapis.com/v0/b/avion-aqua.appspot.com/o/images%2Fjeera.png?alt=media&token=e90f2aad-1f32-43c6-936b-543cf469b130",
    heading: "Jeera",
  },
  {
    image:
      "https://firebasestorage.googleapis.com/v0/b/avion-aqua.appspot.com/o/images%2Frush.png?alt=media&token=9957bb9a-484a-4cf2-992c-ac970f64dbe8",
    heading: "Rush",
  },
  {
    image:
      "https://firebasestorage.googleapis.com/v0/b/avion-aqua.appspot.com/o/images%2Fsprint.png?alt=media&token=641b8a59-092a-4363-8267-dfb9aac46b60",
    heading: "Sprint",
  },
];
